const en = [
  {
    type: ['bottom'],
    image: 'gallery/enNew/1-1.webp',
    title: 'Development/Construction',
    text: 'ImmoProperty LTD project',
    planId: 'fc820593-e625-484f-b5a6-c7025816ed40',
  },
  {
    image: 'gallery/enNew/1-2.webp',
    title: '3D Digital studio',
    text: 'Cottage community',
    planId: '8c78317f-4d44-4671-a3e8-2b3545dadfb3',
  },
  {
    image: 'gallery/enNew/1-3.webp',
    title: 'Development/Construction',
    text: 'Richford project',
    planId: 'ac8f87cb-a97b-42b9-a078-74c5c8db9726',
  },
  {
    image: 'gallery/enNew/1-4.webp',
    title: 'Development/Construction',
    text: 'Old Town',
    planId: '5b360b33-5afb-41af-9769-e7c34e690a7b',
  },
  {
    type: ['bottom'],
    image: 'gallery/enNew/1-5.webp',
    title: '3D Digital studio',
    text: 'PrimProperty ',
    planId: 'c1855bc7-b79a-4dc8-8f79-8d9de9236109',
  },
  {
    image: 'gallery/enNew/2-1.webp',
    title: 'Development/Construction',
    text: 'Suburban/Farm Dark',
    planId: '90f6b3ec-79e8-42ac-a35f-f50215de838c',
  },
  {
    type: ['bottom'],
    image: 'gallery/enNew/2-2.webp',
    title: 'Development/Construction',
    text: '3d offices Dark project',
    planId: '92c040fb-21fc-4ca4-8501-e137de794ac6',
  },
  {
    image: 'gallery/enNew/2-3.webp',
    title: 'Development/Construction',
    text: 'Palmbeach Con Jardin',
    planId: 'aa53b93a-5c79-415e-952c-17e3ab62f6cf',
  },
  {
    type: ['bottom'],
    image: 'gallery/enNew/2-4.webp',
    title: 'Development/Construction',
    text: 'Hytte',
    planId: 'e619f2a8-b6d3-4a2f-bc81-f63a8d0b100a',
  },
  {
    image: 'gallery/enNew/2-5.webp',
    title: 'Development/Construction',
    text: 'Jaconda',
    planId: '5171bb0a-8246-4d35-91c7-ddb9a02c7289',
  },

  {
    image: 'gallery/enNew/3-1.webp',
    title: 'Real Estate Management',
    text: '3D for NY community',
    url: 'https://getfloorplan.com/public_fp/69865f57-c5a7-44de-b632-2ce9ab842b16',
  },
  {
    image: 'gallery/enNew/3-2.webp',
    title: 'Development/Construction',
    text: 'Minimalist',
    planId: '3cff9da8-dd97-4df2-9edb-5c64bbe16b7a',
  },
  {
    image: 'gallery/enNew/3-3.webp',
    title: 'Development/Construction',
    text: 'Richford project',
    planId: '0bde1d87-6484-47a5-a63b-502dc3ed6968',
  },
  {
    image: 'gallery/enNew/3-4.webp',
    title: 'Development/Construction',
    text: 'Wood Classic',
    planId: 'f82ab141-9be2-41b2-8e12-9dbf966ff5b2',
  },
  {
    type: ['offset18'],
    image: 'gallery/enNew/3-5.webp',
    title: 'Development/Construction',
    text: 'Trendy',
    planId: 'ce71f3b6-ca77-4c98-b754-a1380e3dbe70',
  },
  {
    image: 'gallery/enNew/4-1.webp',
    title: 'Development/Construction',
    text: 'Traditional',
    planId: '60127cc1-36a4-4e02-b8a0-898cf26f0cec',
  },
  {
    type: ['offset14'],
    image: 'gallery/enNew/4-2.webp',
    title: 'Development/Construction',
    text: 'Rustic',
    planId: '3711d9ab-9d4e-4fa6-9e91-d1a8075db8ac',
  },
  {
    image: 'gallery/enNew/4-3.webp',
    title: 'Real Estate Management',
    text: 'Renders for Real Estate Management',
    url: 'https://getfloorplan.com/public_fp/f5571ad4-caaa-416d-91c3-98832c7793d9',
  },
  {
    type: ['offset10'],
    image: 'gallery/enNew/4-4.webp',
    title: '3D Digital studio',
    text: 'Scandy Studio',
    planId: 'dede909e-d4ad-402f-9aac-c93505cbeab6',
  },
  {
    image: 'gallery/enNew/4-5.webp',
    title: 'Real Estate Management',
    text: 'Florida com.Rent',
    url: 'https://getfloorplan.com/public_fp/34e2563d-3744-44df-914c-eaf400e817fc',
  },
];

export const gallery = { en, ru: en };
